export default __webpack_public_path__ + "static/media/happy (Gustixa ft. Nida Havia).8acd6776.mp3";